import { deleteSeriesSeriesIdFavorite } from "src/api/v2/series/[series_id]/favorite/delete"
import { SeriesSeriesIdFavoriteDeleteInputModel } from "src/api/v2/series/[series_id]/favorite/DeleteInputModel"

export const removeFavorite = (seriesId: string): Promise<void> => {
  return deleteSeriesSeriesIdFavorite(
    new SeriesSeriesIdFavoriteDeleteInputModel(seriesId),
  )
}
